import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Dashboard',
  tabs: {
    [tabs.general]: 'Generelt',
    [tabs.overview]: 'Oversigt',
    [tabs.orders]: 'Ordrer efter kilde',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Kunder',
    [tabs.order_conversion]: 'Ordrekonvertering',
    [tabs.mobile_app]: 'Mobilapp',
  },
  date_range: {
    this_month: 'Denne måned',
    last_month: 'Sidste måned',
    last_week: 'Sidste uge',
    this_week: 'Denne uge',
    this_year: 'I år',
    last_year: 'Sidste år',
    today: 'I dag',
    yesterday: 'I går',
    all: 'Alle',
  },
  buttons: {
    view_key_info: 'Se nøgleinfo',
  },
  empty_franchise: {
    description: 'Dette brand har endnu ingen restaurant. Vælg et andet brand i menuen for at se dets tal.',
  },
};
